import React, { ReactNode, useEffect } from 'react'

import Toast from 'syf-component-library/ui/patterns/Toast'
import { scrollToComponent } from 'helpers/windowUtility'
import styled from 'styled-components'
import { Container, Message } from './subcomponents'

const ToastCL = styled(Toast)`
  & svg {
    width: 24px;
    height: 24px;
  }
`

interface AlertBannerProps {
  type?: 'error' | 'warning' | 'success' | 'info'
  children?: ReactNode
  /**
   * This prop can be set true to scroll back to the banner
   */
  scrollToOnMount?: boolean
  useLockIcon?: boolean
  id?: string
}

const AlertBanner = ({
  type,
  children,
  scrollToOnMount,
  useLockIcon,
  ...props
}: AlertBannerProps) => {
  const containerRef = React.useRef(null)

  const isOnlyText = typeof children === 'string'

  useEffect(() => {
    if (scrollToOnMount) {
      scrollToComponent(containerRef)
    }
  }, [scrollToOnMount])

  return (
    <Container role="alert" ref={containerRef} {...props}>
      <ToastCL
        closeHandler={(): void => null}
        hasClose={false}
        className="toastContainer"
        type={type}
        data-test="message-container"
      >
        {isOnlyText ? (
          <Message data-test="message-content">{children}</Message>
        ) : (
          children
        )}
      </ToastCL>
    </Container>
  )
}

export default AlertBanner
